import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';

export function useTimeTrackingActivityDeleteHandler(
  timeTrackingActivity: TimeTrackingActivity
): () => void {
  return useEntityDeleteHandler(
    EntityName.TimeTrackingActivity,
    timeTrackingActivity,
    (activity) => activity.name
  );
}
